module.exports = __webpack_public_path__ + "static/img/003.0446db8a.png";